import { Component } from '@angular/core';
import { HostListener } from '@angular/core';
import * as $ from "jquery";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'app';
  // imgs = new Array();
  // ngOnInit() {
  //   this.pload(
  //     "//assets/cover.jpg",
  //   "//assets/images-1.jpg");
  // }

  // pload(...args: any[]):void {
  //   for (var i = 0; i < args.length; i++) {
  //     this.imgs[i] = new Image();
  //     this.imgs[i].src = args[i];
  //     console.log('loaded: ' + args[i]);
  //   }
  // }
  Testing() {
    var menu = $("#navMenu");
    $('#navMenu').toggle();
    if ($('#navMenu').is(':visible')) {
      $('.navbar__toggle').addClass('clicked');
    } else {
      $('.navbar__toggle').removeClass('clicked');
    }
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (document.documentElement.scrollTop > 80) {
      $('.navbar').addClass('scrolled');
    } else {
      $('.navbar').removeClass('scrolled');
    }
    var scrollheight = $('.cover').height();
    if (document.documentElement.scrollTop > scrollheight ) {
      $('.navbar').addClass('navbar--bg');
    } else {
      $('.navbar').removeClass('navbar--bg');
    }
  }



}
